import { ApprovalState } from '@fdm/api-client';

export function approvalStatusNaming(status: ApprovalState) {
  switch (status) {
    case ApprovalState.Draft:
    case ApprovalState.DraftedForReview:
    case ApprovalState.SubmittedToOpsAdvisor:
    case ApprovalState.PlanConfirmed:
    case ApprovalState.RIPTScored:
    // case ApprovalState.RIPTSkipped:
    // case ApprovalState.RIPTScoredSkipped:
    case ApprovalState.RiskEvaluationScored:
    case ApprovalState.PlanEndorsed:
    case ApprovalState.Recycle:
      return 'Preparation in progress';
    case ApprovalState.PlanApproved:
    case ApprovalState.ResolutionPlanCompleted:
    case ApprovalState.ValidationAndVerificationCompleted:
      return 'Execution in progress';
    case ApprovalState.Closed:
      return 'Closed';
    case ApprovalState.Cancelled:
      return 'Cancelled';
    case ApprovalState.OutOfService:
      return 'Out of service';
    default:
      return '-';
  }
}
